import HttpRequest from "./http_request";

class ExecuteProvider extends HttpRequest {
  constructor() {
    // api api
    super(process.env.VUE_APP_API_URL);
  }

  async setStudentStatus({
    level_id,
    keyword,
    grad_year,
    grad_semester,
    grad_date,
    list_student_id,
  }) {
    const { data } = await this.update("/", {
      function: "set-student-status",
      level_id,
      keyword,
      grad_year,
      grad_semester,
      grad_date,
      list_student_id,
    });
    return data;
  }
}

export default ExecuteProvider;
